<template>
    <div class="container">
        <div class="klantenvertellen-block-large row flex-column-reverse flex-md-row-reverse">
            <div v-if="hasRating" class="content-wrapper dark-theme col-12 col-md-7 no-gutters">
                <div class="inner">
                    <h2 v-html="ourCustomerRating"></h2>

                    <div class="rating-wrapper">
                        <div class="grade">
                            {{ score }}
                        </div>

                        <div>
                            <div class="rating" :style="`--rating: ${percentage}`"></div>

                            <p class="mb-0">{{ basedOnText }}</p>
                        </div>

                        <a href="https://www.kiyoh.com/location-group/carprof_be" class="cta-link" target="_blank">{{ seeReviews }}</a>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-5">
                <div class="image-wrapper">
                    <div class="image"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {klantenvertellenOptions} from '../mixins/klantenvertellen';

export default {
    name: "ReviewBlock",

    mixins: [klantenvertellenOptions],

    data() {
        return {
            ourCustomerRating: window.Drupal.t(`<span class="color-main">Our customers</span> rate us with a`),
            seeReviews: window.Drupal.t('See reviews')
        }
    },
}
</script>